import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
// import Header from './Header';
// import Sidebar from './SideBar';
import ExpenseModal from './ExpenseModal';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
// ✅ Toastify
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../Header';
import Sidebar from '../SideBar';
import { useSidebar } from '../../SidebarContext';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Search,
  X
} from "lucide-react";
import { useSearch } from '../../SearchContext';
import { useFilter } from '../../FilterContext';
import FilterDrawer from '../FilterDrawer';
import Loader from '../Loader';
import ExpenseSummary from './ExpenseSummary';
import { decryptToken } from '../utils/getToken';

const IndividualExpenses = () => {
  const location = useLocation();
  const submittedData = location.state;
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [customers, setCustomers] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState(customers);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const url = API_BASE_URL
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isDateFilterApplied, setIsDateFilterApplied] = useState(false);
  const [isImportOpen, setImportOpen] = useState(false);
  const toggleImport = () => setImportOpen(!isImportOpen);
  const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate()
  const { globalSearch } = useSearch();
  const { entriesPerPage, sortOrder, showDrawer, setShowDrawer, customDate } = useFilter();
  const [load, setLoad] = useState(false);
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [isNoteExpanded, setIsNoteExpanded] = useState(false);
  const token = decryptToken("accessToken") || ""
  console.log("customDate", customDate);
  const [showSearchBar, setShowSearchBar] = useState(false);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("openExpense") === "true") {
      const newUrl = `${window.location.pathname}`;
      window.history.replaceState({}, "", newUrl);
      setIsModalOpen(true)
    }
  }, [location]);



  const safeDate = (dateStr) => {
    try {
      if (!dateStr || dateStr === "0000-00-00") return "N/A";

      const parsedDate = new Date(dateStr);

      // Check if it's a valid date
      if (isNaN(parsedDate.getTime())) return "N/A";

      return parsedDate.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return "N/A";
    }
  };



  const fetchExpenses = async () => {
    setLoad(true); // Start loader
    try {
      const res = await fetch(`${url}/api/expenses/all/${isLoggedIn.main_id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await res.json();
      const formattedData = data.map(item => ({ ...item, isEditing: false }));
      setCustomers(formattedData.reverse());
    } catch (err) {
      console.error("Failed to fetch expenses:", err);
    } finally {
      setLoad(false); // Stop loader in both success or failure
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);



  let filteredExpenses = [...customers];

  // 1. Filter by date
  if (customDate.from || customDate.to) {
    const from = customDate.from ? new Date(customDate.from) : null;
    const to = customDate.to ? new Date(customDate.to) : null;

    if (to) to.setHours(23, 59, 59, 999); // include full day

    filteredExpenses = filteredExpenses.filter((item) => {
      const createdAt = new Date(item.date);

      const passes =
        (!from || createdAt >= from) &&
        (!to || createdAt <= to);


      return passes;
    });
  }

  const searchText = showSearchBar ? searchQuery : globalSearch;

  if (searchText.trim()) {
    const search = searchText.toLowerCase();
    filteredExpenses = filteredExpenses.filter((item) =>
      (item.customer || "").toLowerCase().includes(search) ||
      (item.invoiceNumber || "").toLowerCase().includes(search) ||
      (item.notes || "").toLowerCase().includes(search) ||
      (item.category || "").toLowerCase().includes(search) ||
      (item.date || "").toLowerCase().includes(search)
    );
  }

  // 3. Sort
  filteredExpenses.sort((a, b) => {
    const dateA = new Date(a.createdAt || a.date);
    const dateB = new Date(b.createdAt || b.date);
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });

  // 4. Pagination
  const totalPages = Math.ceil(filteredExpenses.length / entriesPerPage);
  const currentData = filteredExpenses.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleDelete = async (customerId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${url}/api/expenses/${customerId}`, {
            method: 'DELETE',
            Authorization: `Bearer ${token}`,
          });
          if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.message || 'Failed to delete');
          }

          Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
          setCustomers((prev) => prev.filter((item) => item.id !== customerId));
        } catch (error) {
          console.error('Delete error:', error.message);
          Swal.fire('Error!', `Failed to delete customer. ${error.message}`, 'error');
        }
      }
    });
  };
  console.log(selectedExpense)
  const totalExpensesAmount = filteredExpenses.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);

  if (load) {
    return (
      <Loader />
    );
  }


  return (
    <>
      <div className="oms-header">
        <h1 className="dashboard-title">Category name</h1>
        <div className="customer-warning-new-hamburger-help">
          {selectedIds.length > 0 && (
            <button
              className="oms-add-btn"
              style={{ backgroundColor: 'red', marginLeft: '10px' }}
              onClick={async () => {
                const confirm = await Swal.fire({
                  title: 'Delete selected?',
                  text: `This will delete ${selectedIds.length} expenses.`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete them!',
                });

                if (confirm.isConfirmed) {
                  try {
                    const res = await fetch(`${url}/api/expenses/expensesall/delete-multiple`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ ids: selectedIds })
                    });

                    const result = await res.json();

                    if (res.ok) {
                      toast.success(result.message || 'Deleted selected expenses.');
                      setCustomers(prev => prev.filter(item => !selectedIds.includes(item.id)));
                      setSelectedIds([]);
                    } else {
                      toast.error(result.message || 'Failed to delete selected expenses.');
                    }
                  } catch (err) {
                    console.error("Bulk delete failed:", err);
                    toast.error("Something went wrong while deleting.");
                  }
                }
              }}
            >
              Delete Selected ({selectedIds.length})
            </button>
          )}

          <div
            className='text-black size-8 rounded-full flex justify-center items-center bg-gray-100 hover:bg-gray-200 cursor-pointer'
            onClick={() => setShowSearchBar(!showSearchBar)}
          >
            <Search size={18} />
          </div>

          <div className="filter-controls">
            <button onClick={() => setShowDrawer(true)} className="more-filters-btn">
              <i className="fa-solid fa-sliders"></i> Filters
            </button>
          </div>

          <div className="import-hamburger" onClick={toggleImport}>
            <i className="fa-solid fa-ellipsis-vertical"></i>
          </div>
          {isImportOpen && (
            <div className="import-ul">
              <ul>
                <li><Link to='/import-expense'><i className="fa-solid fa-file-arrow-down"></i> Import Expenses</Link></li>

                {/* <li onClick={handleRefresh}><i className="fa-solid fa-rotate"></i> Refresh List</li> */}
              </ul>
              <ul>
                <li><Link to='/export-expense'><i className="fa-solid fa-file-arrow-up"></i> Export Expenses</Link></li>

                {/* <li onClick={handleRefresh}><i className="fa-solid fa-rotate"></i> Refresh List</li> */}
              </ul>
              <ul>
                <li>
                  <a
                    href="/sample_expense.xlsx"
                    download
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fa-solid fa-file-arrow-down"></i> Download Sample
                  </a>

                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {showSearchBar && (
        <div className="w-full my-3 p-0">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="Search Expenses..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
              className="w-full border border-gray-300 rounded-full px-4 py-2 pr-10 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
            <button
              onClick={() => {
                setShowSearchBar(false);
                setSearchQuery('');
              }}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              <X size={18} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      )}

      {/* <div className="oms-date-filter">
          <button className="oms-add-btn" onClick={() => setShowDateFilter(!showDateFilter)}>
            Filter by Date
          </button>

          {showDateFilter && (
            <div className="date-range-picker" style={{ marginTop: "10px", display: 'flex', gap: '10px', alignItems: 'center' }}>
              <label>From:</label>
              <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
              <label>To:</label>
              <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
              <button onClick={filterByDate}>Apply</button>
            </div>
          )}
        </div> */}

      <div className="ecom-search-filter">
        {/* Search Filter */}
        {/* <div className="filter-search">
            <div className="filter-search-input">
              <input
                type="search"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearch}
              />
              <i className="fa fa-search"></i>
            </div>
          </div> */}
        {/* Filter Date Right */}
        {/* <div style={{ position: 'relative', marginTop: "15px" }}>
            <button className="oms-add-btn" onClick={isDateFilterApplied ? clearDateFilter : () => setShowDateFilter(!showDateFilter)}>
              <i className="fa-solid fa-calendar-days"></i> {isDateFilterApplied ? "Clear Filter" : "Filter by Date"}
            </button>


            {showDateFilter && (
              <div
                className="date-modal-popup"
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '110%',
                  backgroundColor: '#fff',
                  padding: '15px',
                  borderRadius: '6px',
                  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  minWidth: '250px',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <label>
                    From:
                    <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                  </label>
                  <label>
                    To:
                    <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                  </label>
                  <button className="oms-add-btn" onClick={filterByDate}>Apply</button>
                </div>
              </div>
            )}
          </div> */}
      </div>
      {/* <div className="payment-summary">
          <p className="payment-head">Payment Summary</p>
          <div className="payment-summary-details" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <div className="payment-summary-list list1 expense-summary-list">
              <i className="fa-solid fa-arrow-down"></i>
              <div className="details">
                <p className="label">Total Expenses</p>
                <h3>Rs. {totalExpensesAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</h3>
              </div>
            </div>
          </div>
        </div> */}


      <div className="customer-table responsive-table">
        <table>
          <thead>

            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={currentData.every(c => selectedIds.includes(c.id)) && currentData.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      // Add only the current page's IDs without duplicates
                      const newIds = currentData
                        .map(c => c.id)
                        .filter(id => !selectedIds.includes(id));
                      setSelectedIds([...selectedIds, ...newIds]);
                    } else {
                      // Remove only the current page's IDs
                      const newIds = selectedIds.filter(id => !currentData.map(c => c.id).includes(id));
                      setSelectedIds(newIds);
                    }
                  }}
                />
              </th>


              <th>Date</th>
              <th>Type</th>
              <th>Attachment</th>
              <th>Category</th>
              <th>Amount</th>
              <th>Invoice No.</th>
              <th>Notes</th>
              <th>Customer</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((customer) => (
                <tr key={customer.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(customer.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds(prev => [...prev, customer.id]);
                        } else {
                          setSelectedIds(prev => prev.filter(id => id !== customer.id));
                        }
                      }}
                    />

                  </td>

                  <td>{customer.date || "N/A"}</td>
                  <td>{customer.expenseType || "N/A"}</td>
                  <td>
                    {
                      customer?.receipt ? (
                        customer.receipt.startsWith("https://drive.google.com") ? (
                          <a href={customer.receipt} target="_blank" rel="noopener noreferrer">View</a>
                        ) : (
                          <a href={`${url}/Images/Expense/${customer.receipt}`} target="_blank" rel="noopener noreferrer">View</a>
                        )
                      ) : "N/A"
                    }

                  </td>
                  <td>{customer.category || "N/A"}</td>
                  <td>{customer.amount || "N/A"}</td>
                  <td>{customer.invoiceNumber || "N/A"}</td>
                  <td>
                    <div
                      style={{
                        maxWidth: expandedNoteId === customer.id ? 'none' : '150px',
                        overflow: expandedNoteId === customer.id ? 'visible' : 'hidden',
                        textOverflow: expandedNoteId === customer.id ? 'unset' : 'ellipsis',
                        whiteSpace: expandedNoteId === customer.id ? 'normal' : 'nowrap',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        setExpandedNoteId((prev) =>
                          prev === customer.id ? null : customer.id
                        )
                      }
                      title={customer.notes}
                    >
                      {customer.notes || "N/A"}
                    </div>
                  </td>


                  <td>{customer.customer || "N/A"}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="edit-btn"
                        onClick={() => {
                          setSelectedExpense(customer);
                          setIsModalOpen(true);
                        }}
                      >
                        <i className="fa-solid fa-pen"></i>
                      </button>
                      <button
                        onClick={() => handleDelete(customer.id)}
                        className="delete-btn"

                      // style={{ marginLeft: '2px' }}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" style={{ textAlign: 'center' }}>No Expense found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="ecom-responsive-cards">
        {currentData.length === 0 ? (
          <p style={{ textAlign: "center", margin: "50px" }}>No Expense Available</p>
        ) : (
          currentData.map((expense, index) => (
            <div className="ecom-responsive-card"
              key={index}
              onClick={() => navigate(`/expense-detail/${expense.id}`)}
              style={{ cursor: "pointer" }}>

              <div className="ecom-responsive-header">
                <p>{expense.invoiceNumber || "—"}</p>
                <p>{safeDate(expense.date)}</p>
              </div>

              <div className="ecom-responsive-body">
                <div className="ecom-responsive-left">
                  <h2>{expense.notes || "No Notes Provided"}</h2>
                  <p>{expense.category || "Uncategorized"}</p>
                </div>

                <div className="ecom-responsive-right">
                  <h4>₹ {expense.amount?.toFixed?.(2) || "0.00"}</h4>
                  {expense?.receipt ? (
                    <button>
                      {expense.receipt.startsWith("https://drive.google.com") ? (
                        <a href={expense.receipt} target="_blank" rel="noopener noreferrer">
                          View receipt
                        </a>
                      ) : (
                        <a href={`${url}/Images/Expense/${expense.receipt}`} target="_blank" rel="noopener noreferrer">
                          View receipt
                        </a>
                      )}
                    </button>
                  ) : null}

                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {totalPages > 1 && (

        <div className="pagination">
          {/* First Page */}
          <button
            onClick={() => paginate(1)}
            disabled={currentPage === 1}
            className="pagination-chev-btn"
          >
            <ChevronsLeft size={18} />
          </button>

          {/* Previous Page */}
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-chev-btn"
          >
            <ChevronLeft size={18} />
          </button>

          {/* Current Page Number Only */}
          <button className="pagination-btn active">
            {currentPage}
          </button>

          {/* Next Page */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-chev-btn"
          >
            <ChevronRight size={18} />
          </button>

          {/* Last Page */}
          <button
            onClick={() => paginate(totalPages)}
            disabled={currentPage === totalPages}
            className="pagination-chev-btn"
          >
            <ChevronsRight size={18} />
          </button>
        </div>
      )}

      {/* ✅ Toast Container */}

      {/* Expense Modal */}
      <ExpenseModal
        isOpen={isModalOpen}
        setIsOpen={(val) => {
          setIsModalOpen(val);
          if (!val) setSelectedExpense(null);
        }}
        editExpense={selectedExpense}
        fetchExpenses={fetchExpenses}
      />

      <FilterDrawer />

      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
        <button
          onClick={() => {
            setSelectedExpense(null)
            setIsModalOpen(true)
            fetchExpenses()

          }}
          className="cssbuttons-io-button">
          <span>Add Expense</span>
        </button>
      </div>
    </>
  );
};

export default IndividualExpenses;
